import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20943d41&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20943d41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20943d41')) {
      api.createRecord('20943d41', component.options)
    } else {
      api.reload('20943d41', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20943d41&scoped=true&", function () {
      api.rerender('20943d41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionList/index.vue"
export default component.exports